import React, { useState, useEffect } from 'react';
import './Header.css';
import { Container } from 'reactstrap';
import SASLOGO from './../../assets/sainik 12345.png';
import HRYLOGO from './../../assets/gov.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, faEnvelope, faMailBulk, faPhone, faVoicemail, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
const Header = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [translateLanguage, setTranslateLanguage] = useState('en');

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const setGoogleTranslateCookie = (language) => {
      const value = language === 'en' ? '/en/en' : `/en/${language}`;
      const hostname = window.location.hostname;

      document.cookie = `googtrans=${value}; path=/`;
      document.cookie = `googtrans=${value}; path=/; domain=${hostname}`;
      if (hostname.includes('.')) {
        document.cookie = `googtrans=${value}; path=/; domain=.${hostname}`;
      }
    };

    setGoogleTranslateCookie('en');
    setTranslateLanguage('en');

    const removeGoogleTranslateArtifacts = () => {
      document.body.style.top = '0px';
      document.documentElement.style.top = '0px';

      document.querySelectorAll('#goog-gt-tt, .goog-te-balloon-frame, body > .skiptranslate').forEach((element) => {
        element.style.display = 'none';
      });
    };

    window.googleTranslateElementInit = () => {
      const container = document.getElementById('google_translate_element');
      if (!container || container.children.length || !window.google?.translate?.TranslateElement) return;

      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,hi',
          autoDisplay: false,
        },
        'google_translate_element'
      );
      removeGoogleTranslateArtifacts();
    };

    if (!document.getElementById('google-translate-script')) {
      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    } else {
      window.googleTranslateElementInit();
    }

    const observer = new MutationObserver(removeGoogleTranslateArtifacts);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

    return () => observer.disconnect();
  }, []);

  const setGoogleTranslateCookie = (language) => {
    const value = language === 'en' ? '/en/en' : `/en/${language}`;
    const hostname = window.location.hostname;

    document.cookie = `googtrans=${value}; path=/`;
    document.cookie = `googtrans=${value}; path=/; domain=${hostname}`;
    if (hostname.includes('.')) {
      document.cookie = `googtrans=${value}; path=/; domain=.${hostname}`;
    }
  };

  const triggerGoogleTranslate = (language, attempt = 0) => {
    const googleSelect = document.querySelector('.goog-te-combo');

    if (!googleSelect) {
      if (attempt < 10) {
        setTimeout(() => triggerGoogleTranslate(language, attempt + 1), 300);
      }
      return;
    }

    googleSelect.value = language;
    googleSelect.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const handleTranslateChange = (e) => {
    const language = e.target.value;
    setTranslateLanguage(language);
    setGoogleTranslateCookie(language);
    triggerGoogleTranslate(language);

    setTimeout(() => triggerGoogleTranslate(language), 250);
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-IN', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric'
    });
  };

  return (
   <div style={{  top: 0, backgroundColor: 'white',  height: 130, zIndex: 10, boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
      <div className='headertop d-flex justify-content-between' style={{ padding: '4px 35px', background: 'linear-gradient(90deg, #008d96 0%, #007a82 50%, #006b73 100%)',color:"white"}}>
        <div className="">
          
          <span style={{ fontWeight: '500' }}>{formatDate(currentDate)}</span>
        </div>
        <div className="text-end header-contact">
      <span className="me-3"> <FontAwesomeIcon icon={faPhone} className='me-2'/><span className="">0172-5210277</span></span>
      <span className=""> <FontAwesomeIcon icon={faEnvelope} className='me-2' /><span className="">dept.sasw-hry@gov.in</span></span>
      <span className="header-translate notranslate" translate="no">
        <select
          className="translate-select"
          value={translateLanguage}
          onChange={handleTranslateChange}
          aria-label="Select language"
        >
          <option value="en">English</option>
          <option value="hi">Hindi</option>
        </select>
        <span id="google_translate_element"></span>
      </span>
      </div>
      </div>
      <header style={{  position: 'relative', background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)' }}>
        <div className='container-fluid cont'>
          <div className="d-flex align-items-center justify-content-center" style={{position:"relative"}}>
            
            <div className="col-md-1 col-xs-4 text-center"  >
              <img src={SASLOGO} alt='Right Logo' width={80}  />
            </div>
            <div className="col-md-9 col-xs-8 mt-3">
              <h3 className='mobiletext' style={{  color: '#008d96', margin: 0 }}>
             <div className='text-dark fw-semibold mobp' style={{fontSize:"1rem"}}>Department of</div>
                <div className='fw-bold mobp' style={{textTransform:"",color:"#008d96"}}>Sainik and Ardh Sainik Welfare, Haryana</div>
                <p className='text-dark fw-semibold mobpb' style={{fontSize:"1rem"}}><i>Government of Haryana</i></p>
              </h3>
            </div>
            <div className="col-md-2 col-xs-4 text-end mobileview" >
              <img src={ HRYLOGO} alt='Department Logo' width={63} />
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
